import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./appIdInput.css";

const AppIdInput = ({ setAppId, setShowAppIdInput }) => {
  const [id, setId] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    const regex = /^[a-f0-9]{24}$/;
    if (!regex.test(id)) {
      setError(
        "Invalid App ID format. Please enter a valid 24-character hexadecimal string."
      );
      return;
    }
    setAppId(id);
    setShowAppIdInput(false);
    history.push(`/${id}`);
  };

  return (
    <div className="centered-form-container">
      <form className="centered-form" onSubmit={handleSubmit}>
        <label>Please enter your application ID:</label>
        <input
          type="text"
          value={id}
          onChange={(e) => {
            setId(e.target.value);
            setError("");
          }}
        />
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default AppIdInput;
